/**
 * Created by filatov on 19.08.2015.
 */
import $ from "jquery"
import {BillingSummaryReportInfo} from 'constants'

export default function DisplayedDataSelector(){}

DisplayedDataSelector.prototype.init = function(selectorId, billingSummaryReportInfo, configChanged){
    this.initialBillingSummaryReportInfo = billingSummaryReportInfo;
    this.isNeedBillingTimeSelector = EnabledFeatures.BRA || this.isBillingTimeSelectorOption(this.initialBillingSummaryReportInfo);
    if(this.isNeedBillingTimeSelector) {
        this.billingStatusFilter = new AT.DropdownListButton( {
                                                      applyTo: selectorId,
                                                      menuCls: "billingStatusFilterMenu",
                                                      cls: "billingStatusFilterButton"
                                                  } );
        this.billingStatusFilter.setDefaultValue( this.billingStatusFilter.getValue() );
        var selectShowTimeRadio = function(){ document.getElementById('radio_show_time').checked = true;};
        this.billingStatusFilter.on("click", function() {selectShowTimeRadio(); configChanged();});
        this.billingStatusFilter.on("change", selectShowTimeRadio);
        this.checkbox_show_average_rates = $("#checkbox_show_average_rates");
        this.checkbox_radio_show_time = $("#radio_show_time");

        $("#billingTimeSelector_showTime").show();
        $("#billingTimeSelector_billableAmount").show();
        $("#billingTimeSelector_timeAndAmount").show();
        $("#billingTimeSelector_rates").show();

        if ( configChanged ) {
            this.billingStatusFilter.on("change", configChanged);
            this.checkbox_show_average_rates.on("click", configChanged);
            this.checkbox_radio_show_time.on("change", configChanged);
        }
    } else {
        $("#billingTimeSelector_billable").show();
        $("#billingTimeSelector_nonBillable").show();
        $("#billingTimeSelector_anyStatus").show();
    }
    
    if ( configChanged )
        $("input[type='radio'][name='infoToShow']").on("change", configChanged);
    
    this.setValue(this.initialBillingSummaryReportInfo);
    return this;
};

DisplayedDataSelector.prototype.isBillingTimeSelectorOption = function ( reportInfo ) {
    return reportInfo == BillingSummaryReportInfo.BILLABLE_AMOUNT ||
           reportInfo == BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT ||
           reportInfo == BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES;
};

DisplayedDataSelector.prototype.getValue = function(){
    if( this.isNeedBillingTimeSelector){
        if(this.checkbox_radio_show_time.attr('checked')) return this.billingStatusFilter.getValue();
        if(this.checkbox_show_average_rates.attr('checked') && ($("#radio_show_time_and_amount" ).attr('checked')))
            return this.checkbox_show_average_rates.attr("value");
    }
    return $("input[type='radio'][name='infoToShow']:checked").val();
};

DisplayedDataSelector.prototype.setValue = function(value){
    if( !value )
    {
        this.checkbox_radio_show_time.prop( 'checked', true );
        return;
    }
    if( this.isNeedBillingTimeSelector )
    {
        if( value == BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS ||
            value == BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS ||
            value== BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS )
        {
            this.checkbox_radio_show_time.prop( 'checked', true );
            this.billingStatusFilter.setActiveItemByValue(value );
            return;
        }
        if( value == BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES )
        {
            $( "#checkbox_show_average_rates" ).prop( 'checked', true );
            $( "#radio_show_time_and_amount" ).prop( 'checked', true );
            return;
        }
    }
    $( "input[name=infoToShow][value=" + this.initialBillingSummaryReportInfo + "]" ).prop( 'checked', true );
};



// WEBPACK FOOTER //
// ./web/js/controls/displayed_data_radiogroup_controls_bs_report.js